<i18n>
{
  "ru": {
    "request_id": "Id запроса",
    "template": "Шаблон",
    "time": "Дата",
    "result": "Результат"
  },
  "en": {
    "request_id": "Request Id",
    "template": "Template",
    "time": "Time",
    "result": "Result"
  }
}
</i18n>
<template>
  <div>
    <!-- <request-modal :callback="requestAdded" :visible.sync="showAddForm" v-if="showAddForm"></request-modal> -->
    <!-- <el-row class="right-align" :gutter="20">
      <el-col>
        <el-button round type="primary" @click="add()">
          {{
          $t('add')
          }}
        </el-button>
      </el-col>
    </el-row> -->
    <el-card>
      <!-- <el-form @submit.native.prevent="search">
        <el-row :gutter="20" class="users-setings-header">
          <el-col :sm="2">
            <h4>{{ $t('filter') }}:</h4>
          </el-col>
          <el-col :sm="4">
            <el-select v-model="filter.client_id" :placeholder="$t('client')" clearable>
              <el-option v-for="(label, key) in clients" :key="key" :label="label" :value="key"></el-option>
            </el-select>
          </el-col>
          <el-col :sm="4">
            <el-select v-model="filter.status" :placeholder="$t('status')" clearable>
              <el-option value="new"></el-option>
              <el-option value="in_progress"></el-option>
              <el-option value="completed"></el-option>
            </el-select>
          </el-col>
          <el-col :sm="4">
            <el-select v-model="filter.result" :placeholder="$t('result')" clearable>
              <el-option value="GREEN"></el-option>
              <el-option value="RED"></el-option>
            </el-select>
          </el-col>

          <el-col :sm="6">
            <el-date-picker
              v-model="filter.time"
              type="daterange"
              range-separator="|"
              :unlink-panels="true"
              :start-placeholder="$t('from')"
              :end-placeholder="$t('to')"
              align="right"
            ></el-date-picker>
          </el-col>

          <el-col :sm="4" class="aligner right">
            <el-button native-type="submit" round type="primary">
              {{
              $t('search')
              }}
            </el-button>
          </el-col>
        </el-row>
      </el-form> -->
      <el-row>
        <el-table
          :data="tableData"
          v-loading="loading"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          :cell-class-name="cellClassName"
          @expand-change="getRequestResult"
          @sort-change="changeSort"
        >
          <!-- <el-table-column type="expand">
            <template slot-scope="props">
              <div v-loading="!props.row.fullResult">
                <pre>{{ JSON.stringify(props.row.fullResult, null, 4) }}</pre>
              </div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="id" width="60" label="#" sortable="custom">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.id }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="request_id"
            width="150"
            :label="$t('request_id')"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">
                <el-popover trigger="hover">
                  {{ scope.row.request_id }}
                  <span
                    slot="reference"
                  >{{ scope.row.request_id.substr(0, 15) }}...</span>
                </el-popover>
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="applicant_id" :label="$t('applicant_id')" sortable="custom">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.applicant_id }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="client_id" width="130" :label="$t('client')" sortable="custom">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ clients[scope.row.client_id] }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="template_id" :label="$t('template')" sortable="custom">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ templates[scope.row.template_id] }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="time" :label="$t('time')" sortable="custom">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.time }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" width="100" :label="$t('status')" sortable="custom">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="result" width="120" :label="$t('result')" sortable="custom">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                :class="{
                  'text-red': scope.row.result === 'RED',
                  'text-green': scope.row.result === 'GREEN'
                }"
              >
                <b>{{ scope.row.result }}</b>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="aligner right"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next"
          :total="pagination.total"
          @current-change="changePage"
        ></el-pagination>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'
// import RequestModal from './RequestModal'
import copy from 'copy-to-clipboard'

export default {
  name: 'idcheckRequestsInfo',
  components: {
    // 'request-modal': RequestModal
  },
  data: () => ({
    filter: {
      sort_field: 'id',
      sort_type: 'DESC',
      status: null,
      client_id: null,
      result: null,
      time: null,
      page: 1
    },

    pagination: {
      total: 0,
      pageSize: 25,
      currentPage: 0
    },

    tableData: [],
    templates: {},
    clients: {},
    loading: true,
    showAddForm: false
  }),
  created() {
    apiRes.post(apiRes.idcheckRequests, { action: 'getShortList' }).then(res => {
      res = res.page_vars.res
      this.templates = res.templates
      this.clients = res.clients
    })
    this.loadRequests()
  },
  methods: {
    search() {
      this.filter.page = 1
      this.loadRequests()
    },
    tableRowClassName(row, index) {
      return row.disabled === 1 ? 'disabled-row' : ''
    },
    cellClassName({ row }) {
      return row.status === 'completed' ? '' : 'hidden-icon'
    },
    processResponse(vars) {
      if (vars) {
        // vars.res.records.forEach(r => {
        //   if (r.date_last) {
        //     r.date_last = new Date(parseInt(r.date_last) * 1000).toLocaleString(this.$locale)
        //   }
        //   if (r.date_orig) {
        //     r.date_orig = new Date(parseInt(r.date_orig) * 1000).toLocaleString(this.$locale)
        //   }
        //   r.show = false
        // })

        this.tableData = vars.res
        this.pagination = {
          total: vars.count,
          currentPage: vars.page,
          pageSize: vars.count_per_page
        }
      } else {
        this.tableData = []
        this.pagination = {}
      }
    },
    parseRequests(promise) {
      this.loading = true
      this.tableData = []
      promise.then((data) => {
        this.processResponse(data.page_vars)
        this.loading = false
      }).catch(() => {
        this.$notify.error({
          title: this.$t('error'),
          message: ''
        })
        this.loading = false
      })
    },
    loadRequests() {
      this.loading = true
      const request = {}
      Object.keys(this.filter).filter(k => !!this.filter[k]).forEach(k => (request[k] = this.filter[k]))
      if (request.time) request.time = request.time.map(d => d.toISOString().slice(0, 10)).join(',')
      this.parseRequests(apiRes.post(apiRes.idcheckRequestsInfo, request, true))
    },
    getRequestResult(row, expanded) {
      if (expanded && !row.fullResult) {
        apiRes.post(apiRes.idcheckRequestsInfo, { action: 'getResult', request_id: row.request_id }).then(res => {
          row.fullResult = res.page_vars.res
        })
      }
    },
    changePage(newPage) {
      this.filter.page = newPage
      this.loadRequests()
    },
    changeSort({ column, prop, order }) {
      this.filter.sort_field = prop
      this.filter.sort_type = order === 'ascending' ? 'ASC' : 'DESC'
      this.loadRequests()
    },
    add() {
      this.showAddForm = true
    },
    requestAdded(pageVars) {
      if (pageVars.res.request_url) {
        copy(pageVars.res.request_url)
        this.$notify.info({ message: `${this.$t('copied')}: request url` })
      }

      this.loadRequests()
    }
  }
}
</script>
